import React, { FC } from "react";
import { AuthWrapper } from "../../AuthWrapper";
import {
  EmployeeDependentDelete,
  EmployeeDependentList,
} from "../../Employee";
import { EmployeeDetailLanding } from '../../Employee/EmployeeDetailLanding';
import { EmployeeDependentChildAddLanding } from '../../Employee/EmployeeDependentChildAddLanding';
import { EmployeeDependentSpouseAddLanding } from '../../Employee/EmployeeDependentSpouseAddLanding';
import { EmployeeDependentDetailLanding } from '../../Employee/EmployeeDependentDetailLanding';
import { DocumentUpload } from '../../DocumentUpload/DocumentUpload';
import { Switch, useRouteMatch } from "react-router-dom";
import { Insurability } from "../../Insurability";
import { PackageWelcome, PlanSelector } from "../";
import { Cart } from "../../Cart";
import { SummaryDetail } from "../../Summary";
import { Finish } from "../../Finish";
import BeneficiariesEditor from "../../Beneficiaries/BeneficiariesEditor";
import { EnrollmentPackageId } from "../../../types/api/primaryKeys/PrimaryKey";
import { useNumberIdsFromRoute } from "../../../hooks/routing/useNumberIdsFromRoute";
import Harmony from "../../Harmony/Harmony";
import { Col, Row } from "react-bootstrap";
import { shouldCartBeVisible } from '../../../utils/CartHelper';

const Landing: FC = () => {
  const match = useRouteMatch();
  const { packageid: packageId } = useNumberIdsFromRoute() as { packageid: EnrollmentPackageId };
  const isCartVisible = shouldCartBeVisible();

  return (
    <Row>
      <Col>
        <Switch>
          <AuthWrapper
            path={`${match.url}/welcome`}
            exact
            render={() => <PackageWelcome packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/employee`}
            exact
            render={() => <EmployeeDetailLanding packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/dependents`}
            exact
            render={() => <EmployeeDependentList packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/dependents-addchild`}
            exact
            render={() => <EmployeeDependentChildAddLanding packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/dependents-addspouse`}
            exact
            render={() => <EmployeeDependentSpouseAddLanding packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/dependents/:dependentid`}
            exact
            render={() => <EmployeeDependentDetailLanding packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/dependents/:dependentid/delete`}
            exact
            render={() => <EmployeeDependentDelete packageId={packageId} />}
          />

          <AuthWrapper
            path={`${match.url}/documents`}
            exact
            render={() => <DocumentUpload packageId={packageId} />}
          />

          <AuthWrapper
            path={`${match.url}/plantypes/:planTypeId`}
            exact
            render={() => (
              <PlanSelector packageId={packageId} />
            )}
          />
          <AuthWrapper
            path={`${match.url}/harmony/:productGroup`}
            exact
            render={() => <Harmony packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/insurability`}
            exact
            render={() => <Insurability packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/summary`}
            exact
            render={() => <SummaryDetail packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/finish`}
            exact
            render={() => <Finish packageId={packageId} />}
          />
          <AuthWrapper
            path={`${match.url}/plantypes/:planTypeId/policy-subscription/:policyId/beneficiaries`}
            exact
            render={() => <BeneficiariesEditor packageId={packageId} />}
          />
        </Switch>
      </Col>

      {isCartVisible && (
        <div className="side-cart-container">
          <Cart packageId={packageId} />
        </div>
      )}
    </Row>
  );
};

export default Landing;
